<template>
    <ul
        v-if="filterTags.length"
        class="l-ss-c-filter-tags"
        :class="{ 'l-ss-c-filter-tags-indented': filterPositionLeft }">
        <li
            v-for="tag in filterTags"
            :key="`filter-tag-${tag.id}`"
            class="l-ss-c-filter-tags-item"
            @click="onFIlterTagClick(tag)">
            <span>{{ tag.value }}</span>
            <i
                v-html="iconCloseThin"
                class="l-ss-c-icon"></i>
        </li>
        <li
            v-if="isShowResetButton"
            class="l-ss-c-filter-tags-reset-button"
            @click="$emit('reset-filters')">
            <span>{{ $t('filters.resetAllText') }}</span>
        </li>
    </ul>
</template>

<script>
    import iconCloseThin from '@/core/assets/images/icons/close-thin.svg';

    export default {
        props: {
            activeFilters: {
                type: Array,
                default: () => ([]),
            },
            filters: {
                type: Array,
                default: () => ([]),
            },
            filterPositionLeft: {
                type: Boolean,
                default: false,
            },
            symbol: {
                type: String,
                default: '',
            },
        },
        computed: {
            iconCloseThin() {
                return iconCloseThin;
            },
            isShowResetButton() {
                return Boolean(this.filterTags?.length > 1);
            },
            categoriesNameMap() {
                let map = {};
                const categoryFilter = this.filters.find(item => item.id === 'category');
                const categoryFilterOptions = categoryFilter?.options || [];

                map = categoryFilterOptions.reduce((accumulator, currentOption) => {
                    accumulator[currentOption.id] = currentOption.name;
                    return accumulator;
                }, {});

                return map;
            },
            filterTags() {
                const tags = [];

                if (this.activeFilters?.length) {
                    this.activeFilters.forEach((activeFilterItem, filterIndex) => {
                        const tag = {};
                        tag.filterIndex = filterIndex;
                        tag.field = activeFilterItem.field;

                        const currentFilterInfo = this.filters.find(item => activeFilterItem.field === item.name);

                        if (!currentFilterInfo) {
                            return;
                        }
                        let unit = currentFilterInfo?.unit || '';
                        const name = currentFilterInfo?.name || activeFilterItem?.field || '';
                        const labelFormatted = this.getLabelFormatted(name);

                        if (!unit && activeFilterItem.field === 'price') {
                            unit = this.symbol;
                        }

                        if (activeFilterItem.options) {
                            activeFilterItem.options.forEach((optionItem, optionIndex) => {
                                const newTag = {};
                                newTag.optionIndex = optionIndex;
                                newTag.value = activeFilterItem.field === 'category' ?
                                    `${labelFormatted}${this.getTagValue(optionItem)}` :
                                    `${labelFormatted}${optionItem} ${unit}`;
                                newTag.id = crypto.randomUUID();
                                newTag.filterIndex = filterIndex;
                                newTag.field = activeFilterItem.field;

                                if (newTag.value) {
                                    tags.push(newTag);
                                }
                            });
                        } else if (activeFilterItem.condition === 'range') {
                            tag.min = activeFilterItem.min;
                            tag.max = activeFilterItem.max;

                            if (activeFilterItem.min && activeFilterItem.max) {
                                tag.value = `${labelFormatted}${activeFilterItem.min} - ${activeFilterItem.max} ${unit}`;
                            } else if (activeFilterItem.min) {
                                tag.value = `${labelFormatted}${this.$t('filters.from')} ${activeFilterItem.min} ${unit}`;
                            } else if (activeFilterItem.max) {
                                tag.value = `${labelFormatted}${this.$t('filters.to')} ${activeFilterItem.max} ${unit}`;
                            }
                            tag.id = crypto.randomUUID();
                            tags.push(tag);
                        } else if (activeFilterItem.field === '_is_available') {
                            if (activeFilterItem.value) {
                                tag.value = this.$t('filters.byType._is_available').checked;
                                tag.id = crypto.randomUUID();
                                tags.push(tag);
                            }
                        }
                    });
                }

                return tags;
            },
        },
        methods: {
            getTagValue(value) {
                if (this.categoriesNameMap[value]) {
                    return this.categoriesNameMap[value];
                }
                return '';
            },
            getLabelFormatted(name) {
                const label = this.$t(`filters.byType.${name}`);
                const resultLabel = label ? (label.label || label.title) || name : name;
                const firstLetter = resultLabel.charAt(0);
                let labelFormatted = firstLetter.toUpperCase() + resultLabel.slice(1);
                return `${labelFormatted}: `;
            },
            onFIlterTagClick(tag) {
                const params = {
                    field: tag.field,
                };

                if (tag.optionIndex !== undefined && tag.filterIndex !== undefined) {
                    if (this.activeFilters[tag.filterIndex].options.length > 1) {
                        const newOptions = this.activeFilters[tag.filterIndex].options.toSpliced(tag.optionIndex, 1);
                        params.options = newOptions;
                    }
                }

                this.$emit('change', params);
            },
        },
    };
</script>
